export const getDeploymentReplacementValue = (value: string, defaultValue: string) => {
	return value.indexOf('#') === 0 ? defaultValue : value;
}

export const environment = {
	SITE_ROOT: getDeploymentReplacementValue('#{SITE_ROOT}', 'https://www.highspeedtraining.co.uk'),
	SEARCH_URL: '/Site.CMS.Modules.Products/Product/Search',
	DeploymentBaseUrl: getDeploymentReplacementValue('#{DeploymentBaseUrl}', '')
}
